module.exports = __webpack_public_path__ + "img/53400.3e97493d.jpg";